import { RovLabelScore } from './RovLabelScore';

export function rovLabelScoreToColorCode(rovLabelScore?: RovLabelScore | null) {
    switch (rovLabelScore) {
        case 'A':
            return '#1F8E30';
        case 'B':
            return '#79B928';
        case 'C':
            return '#D3D800';
        case 'D':
            return '#FFEF18';
        case 'E':
            return '#FECF23';
        case 'F':
            return '#F39000';
        case 'G':
            return '#E41613';
        default:
            return '#ECECEC'; // '#3bafda';
    }
}
